import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UsersService } from '../phone-numbers/users/users.service';
import { Ng1AccountService } from '../shared/ng1/ng1-account.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'cc-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {
  public form: FormGroup;
  private accounts = [];

  constructor(private usersService: UsersService, private ng1AccountService: Ng1AccountService) {}

  ngOnInit() {
    this.form = new FormGroup({
      search: new FormControl('')
    });

    this.usersService.getAccounts().subscribe((accounts: any[]) => {
      this.ng1AccountService.setAccountsLength(accounts.length);

      if (accounts.length === 1) {
        this.choose(this.accounts[0]);
      }

      this.accounts = accounts;
    });
  }

  get getFilteredAccounts() {
    return this.accounts.filter(account => account.name.toLowerCase().includes(this.form.get('search').value.toLowerCase()));
  }

  choose(account) {
    if (account.clientType.startsWith('SHOPER')) {
      const token = localStorage.getItem('ngStorage-authToken').replace(/\"/g, '');
      window.location.href = `${environment.SHOPER_CONNECT_URL}/login#access_token=${token}&account=${account.domain}`;
    } else {
      this.ng1AccountService.choose(account);
    }
  }
}
